import { supabase } from '@shared/lib/supabase';

/**
 * Cabeçalhos JSON com o token da sessão atual (Bearer), para as rotas do servidor que exigem
 * login (OTP, SMS, e-mail, pré-cadastro, lançamento de descarte).
 */
export async function getAuthHeaders(): Promise<Record<string, string>> {
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (session?.access_token) {
      headers['Authorization'] = `Bearer ${session.access_token}`;
    }
  } catch {
    // Sem sessão: o servidor responde 401 e a tela mostra o erro
  }
  return headers;
}
